export const FixIDS = {
  Dashboard_And_Analytics: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  Sample_management: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Instrument_management: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  Certification_generation: { List: 13, Add: 14, Edit: 15, Delete: 16, Download: 576 },
  Quality_management: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Report_genration: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  Customer_management: { List: 25, Add: 26, Edit: 27, Delete: 28, View: 577, Download: 578 },
  Audit_and_traceability: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  User_management: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  Security_and_compliance: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  imperiaity: { List: 41, Add: 42, Edit: 43, Delete: 44, View: 579, Download: 580 },
  confidentiality: { List: 45, Add: 46, Edit: 47, Delete: 48, View: 581, Download: 582 },
  legel_entity: { List: 49, Add: 50, Edit: 51, Delete: 52, View: 475 },
  organization_chart: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  quality_policy: { List: 57, Add: 58, Edit: 59, Delete: 60 },
  objectives: { List: 61, Add: 62, Edit: 63, Delete: 64 },
  scope_of_laboratory: { List: 65, Add: 66, Edit: 67, Delete: 68, View: 476 },
  quality_manual: { List: 69, Add: 70, Edit: 71, Delete: 72, View: 477 },
  procedure_manual: { List: 73, Add: 74, Edit: 75, Delete: 76, View: 478 },
  is_standard: { List: 77, Add: 78, Edit: 79, Delete: 80, View: 479 },
  personnel_details: { List: 81, Add: 82, Edit: 83, Delete: 84, View: 481 },
  training_details: { List: 85, Add: 86, Edit: 87, Delete: 88, View: 482 },
  environmental_condition: { List: 89, Add: 90, Edit: 91, Delete: 92, View: 483 },
  intermediate_check: { List: 93, Add: 94, Edit: 95, Delete: 96, View: 485 },
  instrument_check: { List: 97, Add: 98, Edit: 99, Delete: 100, View: 486 },
  metrological_traceability: { List: 101, Add: 102, Edit: 103, Delete: 104, View: 487 },
  externally_provided: { List: 105, Add: 106, Edit: 107, Delete: 108, View: 488 },
  review_of_request: { List: 109, Add: 110, Edit: 111, Delete: 112, View: 489 },
  repeatability: { List: 113, Add: 114, Edit: 115, Delete: 116, View: 490 },
  reproducibility: { List: 117, Add: 118, Edit: 119, Delete: 120, View: 491 },
  quality_control_plan: { List: 121, Add: 122, Edit: 123, Delete: 124, View: 494 },
  calibration_item: { List: 125, Add: 126, Edit: 127, Delete: 128, View: 495 },
  measurement_uncertainty: { List: 129, Add: 130, Edit: 131, Delete: 132, View: 496 },

  
  //use_of_reference_material: { List: 133, Add: 134, Edit: 135, Delete: 136 },
  use_of_alternative_instrument: {
    List: 137,
    Add: 138,
    Edit: 139,
    Delete: 140,
    View: 498
  },
  replicate_testing: { List: 141, Add: 142, Edit: 143, Delete: 144, View: 499 },
  retesting_testing: { List: 145, Add: 146, Edit: 147, Delete: 148, View: 500 },
  blind_sample: { List: 149, Add: 150, Edit: 151, Delete: 152, View: 501 },
  ilc: { List: 153, Add: 154, Edit: 155, Delete: 156, View: 502 },
  pt: { List: 157, Add: 158, Edit: 159, Delete: 160, View: 503 },
  complaint: { List: 161, Add: 162, Edit: 163, Delete: 164, View: 504 },
  non_confirming_work: { List: 165, Add: 166, Edit: 167, Delete: 168, View: 507 },



  internal_audit: { List: 169, Add: 170, Edit: 171, Delete: 172, View: 508 },
  mrm: { List: 173, Add: 174, Edit: 175, Delete: 176, View: 509 },
  risk_and_opportunity: { List: 177, Add: 178, Edit: 179, Delete: 180, View: 510 },

  external_audit: { List: 181, Add: 182, Edit: 183, Delete: 184, View: 575 },

  traceability_logs: { List: 185, Add: 186, Edit: 187, Delete: 188 },

  sample_report: { List: 189, Add: 190, Edit: 191, Delete: 192, Report: 511, Report_Download: 512 },
  instrument_report: { List: 193, Add: 194, Edit: 195, Delete: 196, Report: 513, Report_Download: 514 },
  customer_report: { List: 197, Add: 198, Edit: 199, Delete: 200, Report: 515, Report_Download: 516  },
  personnel_report: { List: 201, Add: 202, Edit: 203, Delete: 204, Report: 517, Report_Download: 518 },
  training_report: { List: 205, Add: 206, Edit: 207, Delete: 208, Report: 519, Report_Download: 520 },
  environmental_report: { List: 209, Add: 210, Edit: 211, Delete: 212, Report: 521, Report_Download: 522 },
  intermediate_check_report: { List: 213, Add: 214, Edit: 215, Delete: 216, Report: 523, Report_Download: 524 },
  instrument_check_report: { List: 217, Add: 218, Edit: 219, Delete: 220, Report: 525, Report_Download: 526 },
  externally_provided_report: { List: 221, Add: 222, Edit: 223, Delete: 224, Report: 527, Report_Download: 528 },
  repetability_report: { List: 225, Add: 226, Edit: 227, Delete: 228, Report: 529, Report_Download: 530 },
  reproducibility_report: { List: 229, Add: 230, Edit: 231, Delete: 232, Report: 531, Report_Download: 532 },
  accuracy_report: { List: 233, Add: 234, Edit: 235, Delete: 236, Report: 533, Report_Download: 534 },
  quality_control_plan_report: { List: 237, Add: 238, Edit: 239, Delete: 240, Report: 535, Report_Download: 536 },
  measurement_uncertainity_report: {
    List: 241,
    Add: 242,
    Edit: 243,
    Delete: 244,
    Report: 537, Report_Download: 538
  },
  use_of_reference_material: { List: 245, Add: 246, Edit: 247, Delete: 248, View: 497, Report: 539, Report_Download: 540 },
  use_of_alternative_instrument_report: {
    List: 249,
    Add: 250,
    Edit: 251,
    Delete: 252,
    Report: 541, Report_Download: 542
  },
  replicate_testing_report: { List: 253, Add: 254, Edit: 255, Delete: 256, Report: 543, Report_Download: 544 },
  retesting_testing_report: { List: 257, Add: 258, Edit: 259, Delete: 260, Report: 545, Report_Download: 546 },
  blind_sample_report: { List: 261, Add: 262, Edit: 263, Delete: 264, Report: 547, Report_Download: 548 },
  ilc_report: { List: 265, Add: 266, Edit: 267, Delete: 268, Report: 549, Report_Download: 550 },
  pt_report: { List: 269, Add: 270, Edit: 271, Delete: 272, Report: 551, Report_Download: 552 },
  complaint_report: { List: 273, Add: 274, Edit: 275, Delete: 276, Report: 553, Report_Download: 554 },
  non_confirming_work_report: { List: 277, Add: 278, Edit: 279, Delete: 280, Report: 555, Report_Download: 556 },
  internal_audit_report: { List: 281, Add: 282, Edit: 283, Delete: 284, Report: 557, Report_Download: 558 },
  mrm_report: { List: 285, Add: 286, Edit: 287, Delete: 288, Report: 559, Report_Download: 560 },
  risk_and_opportunity_report: { List: 289, Add: 290, Edit: 291, Delete: 292, Report: 561, Report_Download: 562 },
  external_audit_report: { List: 293, Add: 294, Edit: 295, Delete: 296, Report: 563, Report_Download: 564 },

  metrological_traceability_report: { List: 565, Report: 566, Report_Download: 567},

  consumable_item_report: { List: 568, Report: 569, Report_Download: 570 },

  Roles: { List: 297, Add: 298, Edit: 299, Delete: 300 },
  User: { List: 301, Add: 302, Edit: 303, Delete: 304 },
  sop: { List: 305, Add: 306, Edit: 307, Delete: 308, View: 480 },
  accuracy: { List: 309, Add: 310, Edit: 311, Delete: 312, View: 492 },
  Country: { List: 313, Add: 314, Edit: 315, Delete: 316 },
  State: { List: 317, Add: 318, Edit: 319, Delete: 320 },
  City: { List: 321, Add: 322, Edit: 323, Delete: 324 },
  Pincode: { List: 325, Add: 326, Edit: 327, Delete: 328 },
  instrument_name: { List: 329, Add: 330, Edit: 331, Delete: 332 },
  model_no: { List: 333, Add: 334, Edit: 335, Delete: 336 },
  serial_no: { List: 337, Add: 338, Edit: 339, Delete: 340 },
  calibrated_by: { List: 341, Add: 342, Edit: 343, Delete: 344 },
  consumable_item: { List: 345, Add: 346, Edit: 347, Delete: 348 },
  method_of_testing: { List: 349, Add: 350, Edit: 351, Delete: 352 },
  samp_recieived_by: { List: 353, Add: 354, Edit: 355, Delete: 356 },
  chemist_assign: { List: 357, Add: 358, Edit: 359, Delete: 360 },
  samp_rec_id: { List: 361, Add: 362, Edit: 363, Delete: 364 },
  tat_days: { List: 365, Add: 366, Edit: 367, Delete: 368 },
  no_of_sample: { List: 369, Add: 370, Edit: 371, Delete: 372 },
  preffered_communication_mode: { List: 373, Add: 374, Edit: 375, Delete: 376 },
  material_tested: { List: 377, Add: 378, Edit: 379, Delete: 380 },
  test_method: { List: 381, Add: 382, Edit: 383, Delete: 384 },
  component: { List: 385, Add: 386, Edit: 387, Delete: 388 },
  designation: { List: 389, Add: 390, Edit: 391, Delete: 392 },
  qualification: { List: 393, Add: 394, Edit: 395, Delete: 396 },
  specialization: { List: 397, Add: 398, Edit: 399, Delete: 400 },
  relevant_training: { List: 401, Add: 402, Edit: 403, Delete: 404 },
  training_field: { List: 405, Add: 406, Edit: 407, Delete: 408 },
  type_of_training: { List: 409, Add: 410, Edit: 411, Delete: 412 },
  service_used: { List: 413, Add: 414, Edit: 415, Delete: 416 },
  room_type: { List: 417, Add: 418, Edit: 419, Delete: 420 },
  nature_of_complaint: { List: 421, Add: 422, Edit: 423, Delete: 424 },
  department: { List: 425, Add: 426, Edit: 427, Delete: 428 },
  type_of_verification: { List: 429, Add: 430, Edit: 431, Delete: 432 },
  test_type: { List: 433, Add: 434, Edit: 435, Delete: 436 },
  tested_by: { List: 437, Add: 438, Edit: 439, Delete: 440 },
  management_data: { List: 441, Add: 442, Edit: 443, Delete: 444 },
  ensuring_the_validity: { List: 445, Add: 446, Edit: 447, Delete: 448 },
  management_system: { List: 449, Add: 450, Edit: 451, Delete: 452, View: 505 },
  customer_type: { List: 453, Add: 454, Edit: 455, Delete: 456 },
  parameters: { List: 457, Add: 458, Edit: 459, Delete: 460 },

  payment_method: { List: 571, Add: 572, Edit: 573, Delete: 574},

  //////////////////////// Abhijith ///////////////////////////
  Dashboard_TAT_Performance: { List: 461 },
  Dashboard_Lab_Status: { List: 462 },
  Dashboard_Invoice_Status: { List: 463 },
  Dashboard_Equipment_Status: { List: 464 },
  Dashboard_Monthly_Transaction: { List: 465 },
  Dashboard_Notification: { List: 466 },
  
  //Accuracy_Form: { Add: 493 },
  
};

export const usersIDS = {
  Admin: 1,
  Customer: 2,
  AreaQualityManager: 3,
  QualityManager: 4,
  TechnicalManager: 5,
  LabTechnicianChemist: 6,
  LabTechnicianAssistant: 7,
  Clark: 8,
  SampleReceiver: 9,
  Sampler: 10,
};

export const SampleManagementStatus = {
  Scheduled: 1,
  InProgress: 2,
  Verified: 3,
  PendingReview: 4,
};
